export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Medium.e7b6c004.ttf";